import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightCarousel = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 11, height: 19, viewBox: "0 0 11 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1.35156 1.21094L9.64104 9.50041L1.35156 17.7899", stroke: "white", strokeWidth: 1.84211 }));
const ForwardRef = forwardRef(SvgArrowRightCarousel);
export default ForwardRef;
